// @flow
import type {Element} from 'react'
import React from 'react'
import flash from 'utils/MiscUtils/flash'
import CSRFToken from 'utils/MiscUtils/CSRFToken'

import SectionItem from 'components/SideBar/ui/SectionItem'

const stopImpersonating = () => {
  fetch('/stop_impersonating', {
    method: 'DELETE',
    headers: {
      'X-CSRF-Token': CSRFToken(),
      'X-Requested-With': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
  }).then((response) => {
    if (response.status === 204) {
      flash.notice('No longer impersonating.')
      window.location.reload()
    }
  })
}

function ImpersonationStopper(): Element<"ul"> {
  return (
    <ul>
      <SectionItem
        title="Stop Impersonating"
        onClick={stopImpersonating}
      />
    </ul>
  )
}

export default ImpersonationStopper
